<template>
  <a-table
    row-key="id"
    size="middle"
    :columns="columnsTable"
    :data-source="strategiesData.items"
    :scroll="scrollStyle"
    :loading="loading"
    :pagination="globalPagination"
    @change="handleTableChange"
  >
    <!--Header de tabla-->
    <template #headerCell="{ column, title }">
      <template v-if="column.key === 'entity' && !isTypeBusiness">
        <span> {{ title }} </span>
      </template>
    </template>

    <!--Cuerpo de tabla-->
    <template #bodyCell="{ column, record, text, index }">
      <template v-if="column.key === 'order'">
        <span class="drag" @dragover.prevent @drop.prevent="handleDrop($event, index)">
          <span class="drag" draggable="draggable" @dragstart="handleDragStart($event, index)">
            <MoreOutlined class="drag__icon" />
            <MoreOutlined class="drag__icon" />
          </span>
          <span class="order__text">{{ index + 1 }}</span>
        </span>
      </template>
      <template v-if="column.key === 'name'">
        <a @click="handleShowStrategyDetails(record.id, record.type_origin, record.name)">
          {{ text }}
        </a>

        <a-tooltip v-if="record.errors_data?.length">
          <template #title>
            Se detectaron {{ record.errors_data?.length }}
            {{ record.errors_data.length === 1 ? "fila" : "filas" }} con exceso de caracteres.
            Descargue el reporte para visualizar el detalle. <br /><br />
            <p>Recuerda que estos SMS no seran enviado por exceso de caracteres.</p>
          </template>
          <a-button type="text" style="padding: 0; height: 22px; margin-left: 5px">
            <WarningOutlined style="color: #faad14" />
          </a-button>
        </a-tooltip>
      </template>

      <template v-if="column.key === 'type_assignment'">
        <span>{{ TYPES_ASSIGNMENT[record.type_assignment] || "-" }}</span>
      </template>

      <template v-if="column.key === 'type_strategy_name'">
        <span>{{ typeStrategyName(record) }}</span>
        <a-tooltip v-if="record?.tts_detail">
          <template #title>
            Audio generado con <br/>Text To Speech.
          </template>
          <InfoCircleOutlined style="margin-left: 4px" />
        </a-tooltip>
      </template>

      <template v-if="column.key === 'entity'">
        <div class="name" v-if="!isTypeBusiness">
          <span>{{ record.entity.name }}</span>
        </div>
      </template>

      <template v-if="column.key === 'portfolio'">
        <div class="name">
          <router-link :to="`/operations/campaigns/?search=${text.name}`">
            {{ text.name }}
          </router-link>
        </div>
      </template>

      <template v-if="column.key === 'created_by'">
        <span>{{ record.created_by?.fullname || "-" }}</span>
      </template>

      <template v-if="column.key === 'base'">
        <div class="name">
          <span>{{ text.name }}</span>
        </div>
      </template>

      <template v-if="column.key === 'stats'">
        <span> {{ record.remaining_phones }} / {{ record.total_phones }} </span>
      </template>

      <template v-if="column.key === 'actions'">
        <span class="actions-cell" id="strategy-actions">
          <strategy-play-button :strategy="record" :dataPlan="dataPlan" />
          <a-popover placement="leftTop" class="actions-popover">
            <template #content>
              <strategy-auto-close-modal
                v-if="isWhatsapp(record) && isPendingToStart(record)"
                :strategy="record"
              />

              <strategy-audio-details-modal
                v-if="isIVRReturn(record) || isIVR(record)"
                :strategy="record"
                @update="$emit('update')"
              />

              <!-- <strategy-settings-modal
                v-if="isIVR(record)"
                :strategy="record"
                @update="$emit('update')"
              /> -->

              <strategy-agents-modal
                v-if="canSetAgents(record)"
                :strategy="record"
                :readonly="record.type_assignment == 2"
              />

              <strategy-download-actions
                :strategy="record"
                @isLoading="getCurrentDownload(record.id, $event)"
              />

              <strategy-regenerator-modal
                v-if="canSetAgents(record)"
                :strategy="record"
                :readonly="record.type_assignment == 2"
              />

              <ModalStrategyTime
                :strategy="record"
                :titleStrategy="record.name"
                v-if="(isEmail(record) && !isStrategyExpired(record)) || (isPredictive(record) && !isStrategyFinalized(record))"
              />
              <modal-marking-speed
                v-if="record.type_strategy_name == 'Predictivo'"
                :strategy="record"
                :strategy-name="record.name"
              />

              <a-button
                block
                danger
                class="table-cell__actions-btn"
                type="text"
                :disabled="record.turned_on"
                @click="handleDelete(record)"
              >
                <template #icon>
                  <DeleteOutlined
                    :style="{
                      fontSize: '16px',
                    }"
                  />
                </template>
                <p>Eliminar estrategia</p>
              </a-button>
            </template>
            <a-button type="text"><EllipsisOutlined /></a-button>
          </a-popover>
          <a-popover
            v-if="showAutoCloseIcon(record)"
            placement="topRight"
            class="auto-close-popover"
            overlayClassName="auto-close-popover-overlay"
          >
            <template #content>
              <p class="auto-close-popover__title">Cierre de tickets sin respuesta ni atención</p>
              <p v-if="Number(record.autoclose_ticket_minutes) > 0" class="auto-close-popover__description">
                Los tickets sin respuesta del contacto ni atención de un agente después de
                <b>{{ formatAutoCloseTime(record.autoclose_ticket_minutes) }}</b>
                desde su creación serán cerrados.
              </p>
              <p v-else class="auto-close-popover__description">
                Los tickets sin respuesta del contacto ni atención por parte de un agente serán
                cerrados manualmente.
              </p>
              <strategy-auto-close-modal :strategy="record" link-only />
            </template>
            <HourglassOutlined style="color: #00000073"/>
          </a-popover>
          <a-tooltip v-if="!scheduleNotExecuted(record)">
            <template #title>
              Para que tu estrategia programada {{ record?.execution_time ? ' inicie automáticamente ' : ' inicie de forma manual ' }} debes:
              <ul class="warning-ul">
                <li v-if="showWarningAgents(record)">
                  Añadir usuarios,
                  <strategy-agents-modal
                    v-if="canSetAgents(record)"
                    type-link
                    :strategy="record"
                    :readonly="record.type_assignment == 2"
                  />                  
                </li>
                <li v-if="showWarningEquivalences(record)">
                  Configurar el equivalente del tipo de grupo “No contacto” de tu campaña,
                  <a-button
                    type="link"
                    style="padding: 0; height: auto"
                    @click="openPortfolioTypifications(record?.portfolio?.id)"
                  >
                    aquí
                  </a-button>
                </li>
              </ul>
            </template>
            <a-button type="link" style="padding: 0" v-if="showWarningIcon(record)">
              <WarningOutlined style="color: #FAAD14" />
            </a-button>
          </a-tooltip>
          <LoadingOutlined v-if="validateDownloading(record.id)" />
        </span>
      </template>

      <template v-if="column.key === 'date_created'">
        <span v-if="text?.length > 3"> {{ formatDate(text, false) }} </span>
        <span v-else> {{ text }} </span>
      </template>

      <template v-if="column.key === 'date_launched'">
        <span> {{ formatDate(text, true) }} </span>
      </template>

      <template v-if="column.key === 'strategy_status'">
        <a-tag v-if="record.strategy_status" :color="StrategyColor?.[text]?.tag">
          <component :is="imageStrategy(text)" />
          {{ StrategyText[text] }}
        </a-tag>
      </template>

      <template v-if="column.key === 'turned_on_by'">
        <a-tooltip v-if="text?.fullname" placement="top">
          <template #title v-if="text.turned_on">
            Estrategia fue ejecutado por:<br />
            {{ text.profile.name }} - {{ text.fullname }}
          </template>
          <template #title v-else>
            Estrategia fue pausada por:<br />
            {{ text.profile.name }} - {{ text.fullname }}
          </template>
          <span> {{ text.fullname }} </span>
        </a-tooltip>
        <span v-else> - </span>
      </template>
    </template>
  </a-table>
  <!--Modal para los detalles de una estrategia-->
  <modal-strategy-details
    v-bind="modalStrategyDetails"
    @onClose="handleCloseModalStrategyDetails"
  />

  <ModalStrategyTime
    ref="strategy-time-modal-aux"
    :strategy="recordAux"
    :titleStrategy="recordAux?.name"
    :showButton="false"
  />
</template>

<script>
// TODO-JOHN: Refactor, remover modals de la tabla
import StrategyAgentsModal from "@/app/strategies/components/modals/StrategyAgentsModal.vue";
import StrategyAudioDetailsModal from "@/app/strategies/components/modals/StrategyAudioDetailsModal.vue";
import StrategyAutoCloseModal from "@/app/strategies/components/modals/StrategyAutoCloseModal.vue";
import StrategySettingsModal from "@/app/strategies/components/modals/StrategySettingsModal.vue";
import StrategyRegeneratorModal from "@/app/strategies/components/modals/StrategyRegeneratorModal.vue";
import StrategyPlayButton from "@/app/strategies/components/buttons/StrategyPlayButton.vue";
import StrategyDownloadActions from "@/app/strategies/components/buttons/StrategyDownloadActions.vue";
import ModalStrategyDetails from "@/app/strategies/components/modals/ModalStrategyDetails.vue";
import ModalStrategyTime from "@/app/strategies/components/modals/ModalStrategyTime.vue";
import ModalMarkingSpeed from "../modals/ModalMarkingSpeed.vue";

import {
  DeleteOutlined,
  MoreOutlined,
  QuestionCircleOutlined,
  LoadingOutlined,
  WarningOutlined,
  InfoCircleOutlined,
  HourglassOutlined,
} from "@ant-design/icons-vue";
import { strategyTableColumns } from "@/app/strategies/utils/constants";

import { defineComponent, inject, computed, createVNode, reactive, ref, watch, onMounted, nextTick } from "vue";
import { useStore } from "vuex";
import { Modal } from "ant-design-vue";
import { dateTimeToSlashFormat } from "@/app/shared/utils/dates";
import {
  humanDateWithSlashFormat,
  humanDateTimeWithSlashFormat,
} from "@/app/shared/utils/constants";
import { useScrollResize } from "@/app/shared/composables/useScrollResize";
import { formatColumnsWithBases } from "@/app/shared/utils/formatColumnsWithBases";
import { EllipsisOutlined } from "@ant-design/icons-vue";
import {
  StrategyType,
  StrategyText,
  StrategyColor,
  StrategyImageName,
  StrategyTypeTextToSpeechText,
  StrategyStatus,
} from "@/app/shared/utils/enums";
import {
  TYPES_ASSIGNMENT,
} from "@/app/strategies/utils/modalStrategy";
import { planConfigServices } from "@/app/common/services/PlanConfigServices";
import { TypeStrategy } from "@/@types/strategies/modalStrategy.ts";

export default defineComponent({
  components: {
    StrategyAgentsModal,
    StrategySettingsModal,
    StrategyRegeneratorModal,
    StrategyPlayButton,
    StrategyDownloadActions,
    DeleteOutlined,
    MoreOutlined,
    ModalStrategyDetails,
    EllipsisOutlined,
    LoadingOutlined,
    ModalStrategyTime,
    ModalMarkingSpeed,
    WarningOutlined,
    StrategyAudioDetailsModal,
    StrategyAutoCloseModal,
    InfoCircleOutlined,
    HourglassOutlined,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const store = useStore();
    const isTypeBusiness = computed(() => user.value?.customer?.type_business == 2);
    const user = computed(() => store.getters["getDataUser"]);
    const dataPlan = computed(() => store.getters["getDataPlanDetails"]);
    const globalFilters = inject("filters");

    const globalPagination = inject("pagination");
    const modalStrategyDetails = reactive({
      visible: false,
      type: "filters",
      strategyId: 0,
      strategyOrigin: 0,
      strategyName: "",
    });

    // DATA TABLE
    const strategiesData = computed(() => store.getters["getStrategyInfo"]);

    const handleFetchStrategyTable = (pagination) => {
      console.log(pagination, "pagination");
      console.log(globalPagination.value);
      globalPagination.value = { ...strategiesData.value.pagination, ...pagination };
    };

    const { scrollStyle } = useScrollResize({ headerMargin: 310 });

    const handleShowStrategyDetails = (id, typeOrigin, name) => {
      modalStrategyDetails.strategyId = id;
      modalStrategyDetails.strategyOrigin = typeOrigin;
      modalStrategyDetails.strategyName = name;
      modalStrategyDetails.visible = true;
    };
    const handleCloseModalStrategyDetails = () => {
      modalStrategyDetails.visible = false;
    };

    const isDownloadingReport = ref(false);
    const reportDownloadList = ref([]);

    const getCurrentDownload = (recordId, isDownloading) => {
      if (isDownloading) {
        reportDownloadList.value.push(recordId);
      } else {
        reportDownloadList.value = reportDownloadList.value.filter((id) => id !== recordId);
      }
    };

    const validateDownloading = (recordId) => {
      return reportDownloadList.value.includes(recordId);
    };

    const showWarningAgents = (record) => {
      return !(record.users?.length > 0);
    }

    const showWarningEquivalences = (record) => {
      const equivalencies = record.equivalences_nc;
      return !(equivalencies && equivalencies?.every((equency) => equency?.result));
    };

    const showWarningIcon = (record) => {
      const isPredictive = record?.type_strategy === StrategyType.predictive;
      if (isPredictive) {
        return showWarningEquivalences(record) || showWarningAgents(record);
      }

      return false;
    };

    const openPortfolioTypifications = (portfolioId) => {
      window.open(`/operations/campaigns/${portfolioId}`);
    };

    const typeStrategyName = (strategy) => {
      if ([TypeStrategy.Ivr, TypeStrategy.IvrReturn].includes(strategy.type_strategy)) {
        const name = StrategyTypeTextToSpeechText[strategy.type_strategy];
        if (strategy.tts_detail)  return name + ' / TTS';
        return name;
      } else {
        return strategy.type_strategy_name;
      }
    }

    return {
      strategiesData,
      scrollStyle,
      isTypeBusiness,
      user,
      modalStrategyDetails,
      handleFetchStrategyTable,
      handleShowStrategyDetails,
      handleCloseModalStrategyDetails,
      isDownloadingReport,
      getCurrentDownload,
      validateDownloading,
      StrategyType,
      StrategyText,
      StrategyColor,
      globalPagination,
      TYPES_ASSIGNMENT,
      dataPlan,
      showWarningEquivalences,
      showWarningAgents,
      showWarningIcon,
      openPortfolioTypifications,
      globalFilters,
      typeStrategyName,
    };
  },
  data() {
    return {
      columns: strategyTableColumns,
      humanDateWithSlashFormat,
      humanDateTimeWithSlashFormat,
      recordAux: null,
    };
  },
  computed: {
    columnsTable() {
      return formatColumnsWithBases({
        columns: this.columns,
        prevColumnTitle: "Campaña",
        enableBases: this.user?.customer?.enable_bases,
      });
    },
    rescheduleStrategyModal() {
      return this.$store.getters["getRescheduleStrategyModal"];
    },
  },
  watch: {
    rescheduleStrategyModal: {
      async handler(newValue) {
        if (newValue.show && newValue.data) {
          const strategyData = newValue.data;
          if (!strategyData.name) return;

          // recargamos la tabla con el filtro de busqueda por nombre de estrategia
          this.globalFilters = {
            search: strategyData.name,
            entity: '',
            portfolio: '',
            type: '',
          };
          await this.$emit("update");

          // buscamos el registro en la data de la tabla por su id
          const itemFind = this.strategiesData.items.find(
            (strategy) => strategy.id === strategyData.strategy_id
          );
          if (!itemFind) return;
          
          this.recordAux = itemFind;
          await nextTick();
          
          if (this.$refs[`strategy-time-modal-aux`])
            this.$refs[`strategy-time-modal-aux`]?.handleShowModal();

          this.$store.commit("RESET_RESCHEDULE_STRATEGY_MODAL");
        }
      },
      immediate: true,
    },
    // strategiesData: {
    //   async handler() {
    //     console.log(this.strategiesData, "strategiesData table");
    //     const rescheduleStrategyData = sessionStorage.getItem("rescheduleStrategyData");
    //     if (rescheduleStrategyData) {
    //       const strategyData = JSON.parse(rescheduleStrategyData);
    //       console.log(strategyData, "strategyData");
    //       const itemFind = this.strategiesData.items.find(
    //         (strategy) => strategy.id === strategyData.id
    //       );
    //       if (strategyData.name && itemFind) {
    //         this.globalFilters = {
    //           search: strategyData.name,
    //           entity: '',
    //           portfolio: '',
    //           type: '',
    //         };
    //         await this.$emit("update");
    //         console.log(this.$refs, '$refs');
    //         if (this.$refs[`strategy-time-modal-aux`])
    //           this.$refs[`strategy-time-modal-aux`]?.handleShowModal();
    //       }
    //       // handleShowStrategyDetails(strategyData.id, strategyData.type_origin, strategyData.name);

    //       sessionStorage.removeItem("rescheduleStrategyData");
    //     }
    //   },
    //   immediate: true,
    // },
  },
  // created() {
  //   this.handleFetchStrategyTable(this.pagination);
  // },
  methods: {
    scheduleNotExecuted(strategy) {
      const showEmailTime = strategy?.execution_time || 0;
      return showEmailTime &&
        new Date(showEmailTime) < new Date() &&
        !strategy?.date_launched;
    },
    showAutoCloseIcon(strategy) {
      return this.isWhatsapp(strategy) && this.isPendingToStart(strategy);
    },
    formatAutoCloseTime(minutes) {
      minutes = Number(minutes);
      if (minutes % 60 === 0) {
        const hours = minutes / 60;
        return `${hours} ${hours === 1 ? "hora" : "horas"}`;
      }
      return `${minutes} minutos`;
    },
    handleTableChange(pagination) {
      this.handleFetchStrategyTable(pagination);
    },
    canSetAgents(strategy) {
      const validTypes = [StrategyType.progressive, StrategyType.predictive, StrategyType.ivrReturn, StrategyType.ivr];
      return validTypes.includes(strategy.type_strategy);
      // const valid = ["Progresivo", "Predictivo", "IVR", "IVR Retorno"];
      // return valid.includes(strategy.type_strategy_name);
    },
    isIVR(strategy) {
      return strategy.type_strategy_name == "IVR";
    },
    isIVRReturn(strategy) {
      return strategy.type_strategy === StrategyType.ivrReturn;
    },
    isEmail(strategy) {
      return strategy.type_strategy === StrategyType.email;
    },
    isPredictive(strategy) {
      return strategy.type_strategy === StrategyType.predictive;
    },
    isWhatsapp(strategy) {
      return strategy.type_strategy === StrategyType.whatsapp;
    },
    isPendingToStart(strategy) {
      return strategy.strategy_status === StrategyStatus.PendingToStart;
    },
    isStrategyFinalized(strategy) {
      const Progress = strategy?.remaining_phones - strategy?.total_phones;
      return Progress === 0;
    },
    isStrategyExpired(strategy) {
      const turned_on = strategy?.turned_on;
      const Progress = strategy?.remaining_phones - strategy?.total_phones;
      if (turned_on == true || Progress === 0) {
        return true;
      }
      return false;
    },
    // Handle drag and drop
    handleDragStart(event, index) {
      const parent = event.target.parentElement.parentElement.parentElement;
      event.dataTransfer.effectAllowed = "move";
      event.dataTransfer.setDragImage(parent, 25, 20);
      event.dataTransfer.setData("index", index);
    },
    handleDrop(event, index) {
      const droppedIndex = event.dataTransfer.getData("index");
      const payload = { from: droppedIndex, to: index };
      this.$store.dispatch("moveStrategyFromIndexes", payload);
    },
    formatDate(date, withTime) {
      return dateTimeToSlashFormat(date, withTime);
    },
    handleDelete(strategy) {
      Modal.confirm({
        title: `¿Estás seguro de eliminar la estrategia "${strategy.name}"?`,
        content:
          "Recuerda que se eliminará toda la data de esta estrategia y no podrás recuperarla.",
        icon: createVNode(QuestionCircleOutlined),
        onOk: () => this.deleteInviteUser(strategy),
        centered: true,
        okText: "Eliminar",
        cancelText: "Cancelar",
      });
    },
    imageStrategy(text) {
      return StrategyImageName[text];
    },
    async deleteInviteUser(strategy) {
      try {
        await this.$store.dispatch("deleteStrategyById", strategy.id);
      } catch (error) {
        this.$message.warning("Algo salió mal, por favor, vuelve a intentarlo");
      }
    },
  },
});
</script>

<style lang="sass" scoped>
.drag
  display: flex
  align-items: center
  cursor: pointer

  &__icon
    font-size: 16px
    color: $gray-1

    &:last-child
      margin-left: -22px

.actions-cell
  display: flex
  align-items: center
  gap: 8px

.order__text
  margin-left: 8px

.auto-close-popover
  display: flex
  align-items: center
  cursor: pointer

  &__title
    font-weight: 600
    margin-bottom: 4px

  &__description
    color: $gray-8
    margin-bottom: 8px

:global(.auto-close-popover-overlay .ant-popover-inner-content)
  max-width: 280px

.info
  margin: 0

.actions-popover.ant-btn
  padding: 5px
  display: flex
  flex-direction: column
  justify-content: center

  .anticon
    font-size: 16px

.warning-ul
  li
    line-height: 1.5
</style>

<style lang="sass">
@import '@/app/shared/assets/table-cell-actions.sass'
</style>
